export class DeviceParamWavesoft {
  sold: number;
}
